import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../assets/Logo.png";
import { useAuth } from "../context/authContext";
import { volverAClase } from "../utils/navigation";

export function ResumenEntreno() {
  const [entreno, setEntreno] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  //Validar que estoy en resumenentreno
  useEffect(() => {
  localStorage.setItem("lastPage", "resumenentreno");
}, []);


  useEffect(() => {
    const entrenos = JSON.parse(localStorage.getItem("historialEntrenos") || "[]");
    if (entrenos.length > 0) {
      setEntreno(entrenos[entrenos.length - 1]); // último guardado
    }
  }, []);

    if (!entreno) {
    return (
      <div className="w-screen min-h-screen bg-gradient-to-br from-gray-950 via-black to-gray-900 text-white">
        <div className="w-full max-w-md mx-auto px-4 pt-5 pb-10">
          <div className="flex items-center justify-between gap-3 mb-6">
            <img
              src={logo}
              alt="CoachCycling"
              className="w-28 h-auto"
            />

            <button
              type="button"
              onClick={() => volverAClase(navigate, user?.uid)}
              className="px-4 py-2 rounded-full border border-white/10 bg-white/5 text-sm font-semibold text-gray-300"
            >
              ← Volver
            </button>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/5 p-7 text-center shadow-xl">
            <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-3xl bg-white/10 text-3xl">
              🚴
            </div>

            <h1 className="mt-5 text-xl font-extrabold">
              No hay entrenos guardados
            </h1>

            <p className="mt-2 text-sm leading-6 text-gray-400">
              Completa una sesión y guárdala para ver aquí tu resumen.
            </p>

            <button
              type="button"
              onClick={() => volverAClase(navigate, user?.uid)}
              className="w-full mt-6 py-4 rounded-2xl bg-gradient-to-r from-green-400 to-emerald-600 font-extrabold text-white shadow-xl"
            >
              Volver a entrenar
            </button>
          </div>
        </div>
      </div>
    );
  }

  const esPremium = entreno.modo === "Premium";

  return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-950 via-black to-gray-900 text-white">
      <div className="w-full max-w-md mx-auto px-4 pt-5 pb-10">

        {/* CABECERA */}
        <div className="flex items-center justify-between gap-3 mb-6">
          <img
            src={logo}
            alt="CoachCycling"
            className="w-28 h-auto"
          />

          <button
            type="button"
            onClick={() => volverAClase(navigate, user?.uid)}
            className="px-4 py-2 rounded-full border border-white/10 bg-white/5 text-sm font-semibold text-gray-300"
          >
            ← Volver
          </button>
        </div>

        {/* BLOQUE DE ÉXITO */}
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.45 }}
          className="relative overflow-hidden rounded-3xl border border-green-400/20 bg-gradient-to-br from-green-500/20 via-emerald-500/10 to-white/5 p-6 text-center shadow-2xl"
        >
          <div className="pointer-events-none absolute -top-16 -right-16 w-40 h-40 rounded-full bg-green-400/10 blur-3xl" />

          <div className="relative">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{
                delay: 0.15,
                type: "spring",
                stiffness: 180,
              }}
              className="mx-auto w-16 h-16 flex items-center justify-center rounded-3xl bg-green-400 text-3xl text-black shadow-xl shadow-green-500/20"
            >
              ✓
            </motion.div>

            <p className="mt-5 text-xs font-black uppercase tracking-[0.22em] text-green-300">
              Sesión completada
            </p>

            <h1 className="mt-2 text-3xl font-black">
              Entreno guardado
            </h1>

            <p className="mt-3 text-sm leading-6 text-gray-300">
              Gran trabajo. Ya tienes tu sesión registrada en el historial.
            </p>

            <div className="mt-5 flex items-center justify-center gap-2">
              <span
                className={`
                  rounded-full
                  border
                  px-3
                  py-1.5
                  text-[10px]
                  font-black
                  uppercase
                  tracking-wider
                  ${
                    esPremium
                      ? "border-yellow-400/20 bg-yellow-500/10 text-yellow-300"
                      : "border-blue-400/20 bg-blue-500/10 text-blue-300"
                  }
                `}
              >
                {esPremium ? "Modo Premium" : "Modo libre"}
              </span>

              <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider text-gray-400">
                {entreno.fecha}
              </span>
            </div>
          </div>
        </motion.div>

        {/* MÉTRICAS PRINCIPALES */}
        <div className="grid grid-cols-3 gap-2 mt-5">
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="rounded-2xl border border-white/10 bg-white/[0.07] px-2 py-4 text-center shadow-lg"
          >
            <p className="text-xl">⏱️</p>

            <p className="mt-2 text-sm font-extrabold text-white">
              {entreno.duracion}
            </p>

            <p className="mt-1 text-[10px] uppercase tracking-wider text-gray-500">
              Duración
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.16 }}
            className="rounded-2xl border border-white/10 bg-white/[0.07] px-2 py-4 text-center shadow-lg"
          >
            <p className="text-xl">🚴</p>

            <p className="mt-2 text-sm font-extrabold text-blue-400">
              {entreno.distancia}
            </p>

            <p className="mt-1 text-[10px] uppercase tracking-wider text-gray-500">
              Distancia
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.22 }}
            className="rounded-2xl border border-white/10 bg-white/[0.07] px-2 py-4 text-center shadow-lg"
          >
            <p className="text-xl">🔥</p>

            <p className="mt-2 text-sm font-extrabold text-orange-400">
              {entreno.calorias}
            </p>

            <p className="mt-1 text-[10px] uppercase tracking-wider text-gray-500">
              Calorías
            </p>
          </motion.div>
        </div>

        {/* RENDIMIENTO */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.28 }}
          className="mt-5 rounded-3xl border border-white/10 bg-white/[0.07] p-5 shadow-xl"
        >
          <div className="flex items-center justify-between gap-3 mb-4">
            <div>
              <p className="text-xs uppercase tracking-widest text-gray-500">
                Rendimiento
              </p>

              <h2 className="mt-1 text-lg font-extrabold">
                Resumen de la sesión
              </h2>
            </div>

            <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-yellow-500/10 text-2xl">
              ⚡
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2">
            <div className="rounded-2xl border border-yellow-400/10 bg-yellow-500/5 px-3 py-3 text-center">
              <p className="text-[10px] uppercase tracking-wider text-gray-500">
                RPM registradas
              </p>

              <p className="mt-1 text-xl font-extrabold text-yellow-300">
                {entreno.cadenciaMedia || 0}
              </p>
            </div>

            <div className="rounded-2xl border border-green-400/10 bg-green-500/5 px-3 py-3 text-center">
              <p className="text-[10px] uppercase tracking-wider text-gray-500">
                Puntos
              </p>

              <p className="mt-1 text-xl font-extrabold text-green-400">
                {entreno.puntos || 0}
              </p>
            </div>

            <div className="rounded-2xl border border-purple-400/10 bg-purple-500/5 px-3 py-3 text-center">
              <p className="text-[10px] uppercase tracking-wider text-gray-500">
                Reacciones
              </p>

              <p className="mt-1 text-xl font-extrabold text-purple-300">
                {entreno.emojis || 0}
              </p>
            </div>
          </div>
        </motion.div>

        {/* INFORMACIÓN DE CLASE */}
        {(entreno.gimnasio || entreno.claseId) && (
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.34 }}
            className="mt-5 rounded-3xl border border-white/10 bg-white/5 p-5 shadow-lg"
          >
            <p className="text-xs uppercase tracking-widest text-gray-500">
              Información de la clase
            </p>

            {entreno.gimnasio && (
              <div className="mt-4 flex items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-green-500/10 text-lg">
                    🏋️
                  </div>

                  <span className="text-sm text-gray-400">
                    Gimnasio
                  </span>
                </div>

                <span className="max-w-[55%] truncate text-sm font-bold text-white">
                  {entreno.gimnasio}
                </span>
              </div>
            )}

            {entreno.claseId && (
              <div
                className={`flex items-center justify-between gap-4 ${
                  entreno.gimnasio
                    ? "mt-3 border-t border-white/10 pt-3"
                    : "mt-4"
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-blue-500/10 text-lg">
                    📌
                  </div>

                  <span className="text-sm text-gray-400">
                    Clase
                  </span>
                </div>

                <span className="max-w-[55%] truncate text-sm font-bold text-white">
                  {entreno.claseId}
                </span>
              </div>
            )}
          </motion.div>
        )}

        {/* MENSAJE MOTIVACIONAL */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-5 rounded-3xl border border-green-400/15 bg-green-500/5 p-5 text-center"
        >
          <p className="text-xl">🔥</p>

          <p className="mt-2 text-sm font-bold text-white">
            Gran trabajo, cada pedalada cuenta
          </p>

          <p className="mt-1 text-xs leading-5 text-gray-400">
            Tu progreso ya forma parte de tu historial.
          </p>
        </motion.div>

        {/* ACCIONES */}
        <div className="mt-6">
          <button
            type="button"
            onClick={() => navigate("/historial")}
            className="w-full py-4 rounded-2xl bg-gradient-to-r from-blue-400 to-indigo-600 font-extrabold text-white shadow-xl"
          >
            📊 Ver historial completo
          </button>

          <button
            type="button"
            onClick={() => volverAClase(navigate, user?.uid)}
            className="w-full mt-3 py-4 rounded-2xl border border-white/10 bg-white/5 font-bold text-gray-300 shadow-lg"
          >
            🚴 Volver a la app
          </button>
        </div>

        <p className="mt-7 text-center text-xs italic text-gray-500">
          You'll Never Train Alone 🚴‍♂️🔥
        </p>
      </div>
    </div>
  );
}

export default ResumenEntreno;